"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS = void 0;
/**
 * TODO WARNING: Unfortunately you can't add any more roles to this collection as the backend does not support this!
 * TODO You will first need to verify that fetchPermittedLabelItems has been updated to allow for multi-permission fetches.
 * TODO then remove these TODOs so nobody else worries about it :)
 */
exports.NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS = ['device::read'];
